import React, { Component } from 'react';
import KYCContainer from '../KYCContainer/KYC';
import Profile from '../../../components/PartnerProfile/PartnerProfile';

class PANCARD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      upload: 2
    };
  }
  onclick_handler = id => {};
  OnSubmit = () => {};
  componentDidMount() {}

  data = {
    pan: 'APPROVED',
    address: 'APPROVED',
    selfie: 'APPROVED',
    bank: 'APPROVED',
    ref: 'APPROVED',
    custom: 'null'
  };
  current_page = {
    general: true,
    pan: false,
    address: false,
    selfie: false,
    bank: false,
    ref: false
  };
  render() {
    return (
      <>
        <KYCContainer
          guideName="Profile"
          kycStep={10}
          data={this.data}
          container={Profile}
          curr_page={this.current_page}
          onclick_handler={this.onclick_handler}
          OnSubmit={this.OnSubmit}
        />
      </>
    );
  }
}
export default PANCARD;
